(function () {
  'use strict';

  function getEventTargetElement(e) {
    if (!e) return null;
    let t = e.target || e.srcElement || null;

    if (t && t.nodeType !== 1) {
      if (e.composedPath && e.composedPath().length) {
        for (const n of e.composedPath()) {
          if (n && n.nodeType === 1) {
            t = n;
            break;
          }
        }
      }

      if (t && t.nodeType !== 1 && 'clientX' in e && 'clientY' in e) {
        const el = document.elementFromPoint(e.clientX, e.clientY);
        if (el) t = el;
      }
    }

    return t && t.nodeType === 1 ? t : null;
  }

  function cnmReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function waitForSwiper(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }

    const maxTries = 50;
    let tries = 0;

    const timer = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else {
        tries++;
        if (tries >= maxTries) {
          clearInterval(timer);
        }
      }
    }, 100);
  }

  function getHeadingText(slide) {
    if (!slide) return '';
    const heading = slide.querySelector('.cnm-branch-heading');
    return heading ? heading.textContent.trim().toLowerCase() : '';
  }

  function reorderJimShoreSlides() {
    const jimShoreLink = document.querySelector('#HeaderMenu-jim-shore');
    if (!jimShoreLink) return;

    const jimShoreItem = jimShoreLink.closest('.cnm-mm-item');
    if (!jimShoreItem) return;

    const wrapper = jimShoreItem.querySelector('.mh-cnm-swiper .swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);
    if (slides.length < 2) return;

    const quickLinksSlide = slides.find(function (slide) {
      return getHeadingText(slide) === 'quick links';
    });

    const typesSlide = slides.find(function (slide) {
      return getHeadingText(slide) === 'types';
    });

    if (!quickLinksSlide || !typesSlide || quickLinksSlide === typesSlide) return;

    wrapper.insertBefore(quickLinksSlide, typesSlide);
  }

  function reorderPreciousMomentsSlides() {
    const preciousMomentsLink = document.querySelector('#HeaderMenu-precious-moments');
    if (!preciousMomentsLink) return;

    const preciousMomentsItem = preciousMomentsLink.closest('.cnm-mm-item');
    if (!preciousMomentsItem) return;

    const wrapper = preciousMomentsItem.querySelector('.mh-cnm-swiper .swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);
    if (slides.length < 2) return;

    const quickLinksSlide = slides.find(function (slide) {
      return getHeadingText(slide) === 'quick links';
    });

    if (!quickLinksSlide) return;

    wrapper.insertBefore(quickLinksSlide, wrapper.firstElementChild);
  }

  function ensureExternalMegaNav(panel) {
    if (!panel) return null;

    const host = panel.parentElement;
    if (!host) return null;

    let nav = host.querySelector('.cnm-mm-nav');

    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'cnm-mm-nav';
      nav.hidden = true;

      nav.innerHTML = `
        <button type="button" class="cnm-mm-nav__btn cnm-mm-nav__btn--prev" data-cnm-mm-prev aria-label="Previous menu columns">
          <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.0566 20.478L11.1348 22.3999L0.25664 11.5218L10.9914 0.640966L12.9266 2.54955L4.08974 11.5111L13.0566 20.478Z" fill="#CED4DA"></path>
          </svg>
        </button>
        <button type="button" class="cnm-mm-nav__btn cnm-mm-nav__btn--next" data-cnm-mm-next aria-label="Next menu columns">
          <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.256836 20.478L2.17869 22.3999L13.0568 11.5218L2.32204 0.640966L0.386906 2.54955L9.22374 11.5111L0.256836 20.478Z" fill="#CED4DA"></path>
          </svg>
        </button>
      `;

      host.appendChild(nav);
    }

    return {
      nav: nav,
      prev: nav.querySelector('[data-cnm-mm-prev]'),
      next: nav.querySelector('[data-cnm-mm-next]')
    };
  }

  function hasOverflow(swiper) {
    if (!swiper) return false;
    return Array.isArray(swiper.snapGrid) && swiper.snapGrid.length > 1 && !swiper.isLocked;
  }

  function updateMegaNav(panel) {
    if (!panel || !panel.__cnmSwiper) return;

    const controls = ensureExternalMegaNav(panel);
    if (!controls) return;

    const swiper = panel.__cnmSwiper;
    const overflow = hasOverflow(swiper);

    controls.nav.hidden = !overflow;

    if (swiper.navigation) {
      swiper.navigation.update();
    }

    if (controls.prev) {
      controls.prev.disabled = !overflow || swiper.isBeginning;
    }

    if (controls.next) {
      controls.next.disabled = !overflow || swiper.isEnd;
    }
  }

  function initMegaSwipers(scope) {
    if (typeof Swiper === 'undefined' || !scope) return;

    reorderJimShoreSlides();
    reorderPreciousMomentsSlides();

    const panels = scope.querySelectorAll('[data-cnm-mm-swiper], .mh-cnm-swiper');

    panels.forEach(function (panel) {
      const parentContent = panel.closest('.mega-menu__content');
      const isHidden = parentContent && parentContent.getAttribute('aria-hidden') === 'true';

      let restore = null;
      if (parentContent && isHidden) {
        const prevVis = parentContent.style.visibility;
        const prevDisp = parentContent.style.display;
        const prevPointer = parentContent.style.pointerEvents;

        parentContent.style.visibility = 'hidden';
        parentContent.style.display = 'block';
        parentContent.style.pointerEvents = 'none';

        restore = function () {
          parentContent.style.visibility = prevVis;
          parentContent.style.display = prevDisp;
          parentContent.style.pointerEvents = prevPointer;
        };
      }

      const scrollbarEl = panel.querySelector('.mh-cnm-swiper_scrollbar');
      const navControls = ensureExternalMegaNav(panel);

      if (panel.__cnmSwiper) {
        panel.__cnmSwiper.update();

        if (panel.__cnmSwiper.navigation) {
          panel.__cnmSwiper.navigation.update();
        }

        if (scrollbarEl && panel.__cnmSwiper.scrollbar) {
          panel.__cnmSwiper.scrollbar.updateSize();
        }

        updateMegaNav(panel);

        if (restore) restore();
        return;
      }

      panel.__cnmSwiper = new Swiper(panel, {
        slidesPerView: 6,
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        navigation: navControls ? {
          prevEl: navControls.prev,
          nextEl: navControls.next
        } : false,
        scrollbar: scrollbarEl ? {
          el: scrollbarEl,
          draggable: true,
          dragSize: 'auto'
        } : false,
        breakpoints: {
          0:    { slidesPerView: 1.2 },
          480:  { slidesPerView: 1.8 },
          640:  { slidesPerView: 2 },
          768:  { slidesPerView: 3 },
          1024: { slidesPerView: 6 },
          1440: { slidesPerView: 6 },
          1660: { slidesPerView: 6 }
        },
        on: {
          init: function () {
            updateMegaNav(panel);
          },
          update: function () {
            updateMegaNav(panel);
          },
          resize: function () {
            updateMegaNav(panel);
          },
          breakpoint: function () {
            updateMegaNav(panel);
          },
          reachBeginning: function () {
            updateMegaNav(panel);
          },
          reachEnd: function () {
            updateMegaNav(panel);
          },
          fromEdge: function () {
            updateMegaNav(panel);
          }
        }
      });

      updateMegaNav(panel);

      if (restore) restore();
    });
  }

  cnmReady(function () {
    const root = document.querySelector('.header__inline-menu');
    if (!root) return;

    const items = Array.from(root.querySelectorAll('.cnm-mm-item'));
    const toggles = Array.from(root.querySelectorAll('[data-cnm-mm="toggle"]'));

    function closeItem(item) {
      if (!item) return;

      const panel = item.querySelector('.mega-menu__content');
      const btn = item.querySelector('[data-cnm-mm="toggle"]');

      item.classList.remove('is-open');

      if (panel) panel.setAttribute('aria-hidden', 'true');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      if (!item) return;

      for (const it of items) {
        if (it !== item) closeItem(it);
      }

      const panel = item.querySelector('.mega-menu__content');
      const btn = item.querySelector('[data-cnm-mm="toggle"]');

      item.classList.add('is-open');

      if (panel) panel.setAttribute('aria-hidden', 'false');
      if (btn) btn.setAttribute('aria-expanded', 'true');

      waitForSwiper(function () {
        if (panel) initMegaSwipers(panel);
      });
    }

    function toggleItem(item) {
      if (!item) return;

      if (item.classList.contains('is-open')) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    function closeAll() {
      for (const it of items) closeItem(it);
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.cnm-mm-item');
        if (!item) return;
        toggleItem(item);
      });
    });

    root.addEventListener('focusin', function (e) {
      const el = getEventTargetElement(e);
      if (!el) return;

      const item = el.closest('.cnm-mm-item');
      if (item) openItem(item);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll();
    });

    function outsideHandler(e) {
      const el = getEventTargetElement(e);
      if (!el) {
        closeAll();
        return;
      }

      if (!el.closest('.header__inline-menu')) closeAll();
    }

    document.addEventListener('mousedown', outsideHandler);
    document.addEventListener('touchstart', outsideHandler, { passive: true });

    root.addEventListener('focusout', function () {
      setTimeout(function () {
        const active = document.activeElement;
        if (!active || !root.contains(active)) closeAll();
      }, 0);
    });

    waitForSwiper(function () {
      initMegaSwipers(root);
    });
  });
})();